/**
 * Where a Live Events row's links go.
 *
 * A flow definition is a node definition — the placement lives in
 * `flow_definition_nodes`, but the flow itself is a row in `node_definitions` —
 * so a step's raise addresses the same list as a node's, through one builder.
 *
 * Only the destinations with more than one call site live here. A builder used
 * once is not duplication, and hoisting it would put its meaning a file away
 * from its only reader.
 */
export const nodeDefinitionUrl = (id: number) => `/automation/node_definitions?node_definition_id=${id}`;
